// desktop.guard.ts
import { Injectable, inject } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TostesStore } from '../store/tostes-store';
import { CreateQuestionnaireWarpComponent } from '../features/create-questionnaire-warp/create-questionnaire-warp.component';
import { QuestionnaireDataComponent } from '../features/questionnaires/features/table-grid/features/questionnaire-data/questionnaire-data.component';
import { TostTypeEnum } from '../shared/models/tostes.model';

@Injectable({
    providedIn: 'root',
})
export class RemoveTostesGuard implements CanDeactivate<QuestionnaireDataComponent> {

    #tostesStore = inject(TostesStore);

    canDeactivate(component: QuestionnaireDataComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        this.#tostesStore.removeAllTost(TostTypeEnum.LOAD);
        return true;
    }
}
